<script>
  import { apiFetch } from "../../lib/api.js";
  import { onMount } from "svelte";
  import { BASE_URL } from "../../stores/BASE_URL";
  import { navigate } from "svelte-routing";
  import { user } from "../../stores/user";
  import { user_cliente_filtro, user_cliente_api } from "../../stores/user-cliente";
  export let id_usuario = 0;

  let isLoading = true;
  let isAdding = false;

  let permisos = [];
  let permisosDisponibles = [];
  let permisosVisibles = [];
  let permiso = 0;

  let acciones = false;

  const getPermisos = async () => {
    const response = await apiFetch(`${BASE_URL}usuario.php?action=getPermisos&id=${id_usuario}`);

    const resp = await response.json();
    permisos = resp.data;

    const permiso_filtro = permisos.find((element) => element.permiso === "filtro");

    const permiso_api = permisos.find((element) => element.permiso === "api");

    if (permiso_filtro) {
      user_cliente_filtro.set({
        id_usuario: id_usuario,
        tipo: "D",
        consultas: 0,
      });
    } else {
      user_cliente_filtro.set({
        id_usuario: 0,
        tipo: "D",
        consultas: 0,
      });
    }

    if (permiso_api) {
      user_cliente_api.set({
        id_usuario: id_usuario,
        consultas: 0,
      });
    } else {
      user_cliente_api.set({
        id_usuario: 0,
        consultas: 0,
      });
    }

    getPermisosDisponibles();
  };

  const getPermisosDisponibles = async () => {
    const response = await apiFetch(`${BASE_URL}permiso.php?action=getPermisos`);
    const resp = await response.json();
    permisosDisponibles = resp.data;
    isLoading = false;

    const idsNoPermitidos = permisos.map((permiso) => permiso.id_permiso);
    permisosVisibles = permisosDisponibles.filter((permiso) => !idsNoPermitidos.includes(permiso.id));

    if (permisosVisibles.length > 0) {
      permiso = permisosVisibles[0].id;
    } else {
      permiso = 0;
    }
  };

  const addPermiso = async () => {
    isAdding = true;
    const formData = new FormData();
    formData.append("id_usuario", id_usuario);
    formData.append("id_permiso", permiso);
    formData.append("action", "addPermiso");
    formData.append("session_id_usuario", $user.idUsuario);

    const response = await apiFetch(`${BASE_URL}usuario.php`, {
      method: "POST",
      body: formData,
    });
    const resp = await response.json();
    if (resp.status == "success") {
      getPermisos();
    }
    isAdding = false;
  };

  const deletePermiso = async (id_permiso) => {
    const formData = new FormData();
    formData.append("id_usuario", id_usuario);
    formData.append("id_permiso", id_permiso);
    formData.append("action", "deletePermiso");
    formData.append("session_id_usuario", $user.idUsuario);

    const response = await apiFetch(`${BASE_URL}usuario.php`, {
      method: "POST",
      body: formData,
    });
    const resp = await response.json();
    if (resp.status == "success") {
      getPermisos();
    }
  };

  onMount(() => {
    if (!$user) {
      navigate("/", { replace: true });
    }

    if ($user.rol == "administrador" || $user.rol == "operaciones") {
      acciones = true;
    }
  });

  getPermisos();
</script>

<div>
  {#if permisosVisibles.length > 0 && acciones}
    <div class="d-flex gap-2 mb-2">
      <select class="form-select" bind:value={permiso}>
        {#if !isLoading}
          {#each permisosVisibles as permiso}
            <option value={permiso.id}>{permiso.permiso}</option>
          {/each}
        {/if}
      </select>
      {#if isAdding}
        <button class="btn btn-primary" disabled>Agregando...</button>
      {:else}
        <button class="btn btn-primary" on:click={addPermiso}>Agregar</button>
      {/if}
    </div>
  {/if}
  <div class="d-flex flex-wrap gap-2">
    {#each permisos as permiso}
      <div class="btn-group btn-group-sm" role="group" aria-label="Large button group">
        <button type="button" class="btn btn-secondary btn-sm" disabled>{permiso.permiso}</button>
        <button type="button" class="btn btn-secondary btn-sm" on:click={() => deletePermiso(permiso.id_permiso)}><i class="bi bi-x"></i></button>
      </div>
    {/each}
  </div>
</div>
